<template>
  <div id="app" :class="{ 'bg-white': $route.meta.template === 'payment' }">
    <el-alert v-if="version" center class="demo-alert" type="error">
      <span slot="title">
        ลิงก์นี้เป็นเวอร์ชันใช้ "สำหรับทดลอง" ใช้งานระบบ MANA
        {{ version }} เท่านั้น หากคุณต้องการใช้ระบบเวอร์ชันใช้งานจริง
        <a href="https://manawork.com" target="_blank">
          <u>กรุณากดที่นี่</u>
        </a>
      </span>
    </el-alert>

    <CheckOnline></CheckOnline>
    <router-view :key="$route.fullPath" />
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
import CheckOnline from "@/components/checkOnline";
import { HTTP_GB, HTTP_MANA_BACK_OFFICE } from "@/service/axios.js";
import qs from "qs";

export default {
  name: "app",
  components: { CheckOnline },
  computed: {
    guideClassOpen() {
      return this.$store.state.guideClassOpen;
    },
    user() {
      return this.$store.state.user;
    },
    token() {
      return this.$store.state.token;
    },
    dialogUpgrade() {
      return this.$store.state.dialogUpgrade;
    },
    workspace() {
      return this.$store.getters.getWorkspace(this.$route.params.workSpaceId);
    },
  },
  sockets: {
    connect() {
      // setInterval(() => {
      //  this.$socket.emit("interval");
      // }, 4000 * 60);
    },
    socketOnUpdateLoadData(data) {
      if (this.workspace && this.workspace._id === data.workspaceId) {
        this.$store.commit(
          "PULL_LOAD_DATA_SUCESSED",
          `${data.key}-${data.workspaceId}`
        );
      } else if (data.key === "member-goal") {
        this.$store.commit("PULL_LOAD_DATA_SUCESSED", data.key);
      } else {
        this.$store.commit("PULL_LOAD_DATA_SUCESSED", data.key);
      }
    },
    async socketOnPaymentDone(data) {
      if (this.user._id === data.userId) {
        if (data.resultCode === "00") {
          this.formUpgrade.step = 6;
          let obj = {
            token: this.token,
          };
          await this.$store.dispatch("FETCH_PAYMENT", obj);
        } else if (data.resultCode === "51") {
          this.alertPaymentCreditInsufficientFunds();
          this.dialogVisibleUpgrade = false;
        } else {
          this.alertPaymentCreditError();
          this.dialogVisibleUpgrade = false;
        }
      }
    },
  },

  watch: {
    dialogUpgrade() {
      this.dialogVisibleUpgrade = this.dialogUpgrade;
    },
  },
  data() {
    var validateExpiration = (rule, value, callback) => {
      if (
        !this.formCreditCard.expirationMonth ||
        !this.formCreditCard.expirationYear
      ) {
        callback(new Error("Please select Expiration Date."));
      } else {
        callback();
      }
    };
    return {
      rules: {
        numUser: [
          {
            required: true,
            message: "กรุณาเลือกจำนวน Users",
            trigger: "blur",
          },
        ],
      },
      version:
        process.env.NODE_ENV == "development"
          ? "v" +
            process.env.VUE_APP_VERSION +
            " [" +
            process.env.VUE_APP_GIT_HASH +
            "]"
          : "",
      formUpgrade: {
        step: 1,
        promotion: null,
        numUser: 1,
      },
      loadingPackage: false,
      dialogVisibleUpgrade: false,
      formCreditCard: {
        name: "",
        number: "",
        expirationMonth: "",
        expirationYear: "",
        cvv: "",
      },
      rulesCreditCard: {
        name: [
          {
            required: true,
            message: "Please input Name.",
            trigger: "blur",
          },
        ],
        number: [
          {
            required: true,
            message: "Please input Card Number.",
            trigger: "blur",
          },
          {
            min: 19,
            max: 19,
            message: "Please input valid Card Number.",
            trigger: "blur",
          },
        ],
        expiration: [{ validator: validateExpiration, trigger: "blur" }],
        cvv: [
          {
            required: true,
            message: "Please input CCV.",
            trigger: "blur",
          },
        ],
      },
      referenceNo: "",
      paymentType: 1,
      creditMonthOptions: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      creditYearOptions: [],
      loadingAddCreditCard: false,
      loadingCheckOut: false,
      totalPaymant: 0,
      tokenCheckOut: "",
    };
  },

  async created() {
    console.log(this.$route);
    if (this.user) {
      setInterval(() => {
        this.checkRefreshToken();
      }, 1000 * 60 * 60 * 23.5);
    }

    for (let index = 0; index < 10; index++) {
      let year = `${new Date().getFullYear() + index}`;
      this.creditYearOptions.push(year.slice(2, 4));
    }
  },
  methods: {
    handleCloseUpgrade() {
      this.formUpgrade = {
        step: 1,
        promotion: null,
        numUser: 1,
      };
      this.$store.commit("SET_DIALOG_UPGRADE", false);

      this.formCreditCard = {
        name: "",
        number: "",
        expirationMonth: "",
        expirationYear: "",
        cvv: "",
      };
      this.loadingAddCreditCard = false;
      this.loadingCheckOut = false;
      this.paymentType = 1;
    },
    selectUpgrade(promotion) {
      this.formUpgrade = {
        step: 2,
        promotion: promotion,
        numUser: 1,
      };
    },
    async buyPackage() {
      try {
        this.loadingPackage = true;

        let obj = {
          packageCode: this.formUpgrade.promotion,
          user: this.formUpgrade.numUser,
          price: this.formUpgrade.promotion === 1 ? 250 : 2700,
          payment: null,
        };

        HTTP_MANA_BACK_OFFICE.defaults.headers.common.Authorization = `Bearer ${this.user.tokenBackoffice.data}`;
        let res = await HTTP_MANA_BACK_OFFICE.post(`api/payment`, obj);

        if (res.data.success) {
          this.totalPaymant = obj.price * obj.user;
          this.referenceNo = res.data.result.referenceNo;
          this.formUpgrade.step = 4;
          this.$store.commit("SET_REFRESH_PAYMENT", true);
          setTimeout(() => {
            this.$store.commit("SET_REFRESH_PAYMENT", false);
          }, 500);
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loadingPackage = false;
      }
    },

    async addCreditCard() {
      try {
        this.$refs["form-credit"].validate().then(async (valid) => {
          if (valid) {
            this.loadingAddCreditCard = true;
            let publicKey = process.env.VUE_APP_GB_PUBLIC_KEY;

            let data = {
              rememberCard: false,
              card: {
                name: this.formCreditCard.name,
                number: this.formCreditCard.number,
                expirationMonth: this.formCreditCard.expirationMonth,
                expirationYear: this.formCreditCard.expirationYear,
                securityCode: this.formCreditCard.cvv,
              },
            };

            HTTP_GB.defaults.headers.common.Authorization = `Basic ${btoa(
              `${publicKey}:`
            )}`;

            let res = await HTTP_GB.post(
              process.env.VUE_APP_GB + "v2/tokens",
              data
            );

            if (res.data.resultCode == "00") {
              this.formUpgrade.step = 5;
              this.tokenCheckOut = res.data.card.token;
            } else if (res.data.resultCode == "02") {
              this.alertPaymentCreditDoNotHonour();
            } else if (res.data.resultCode == "54") {
              this.alertPaymentCreditExpiredCard();
            } else {
              this.alertPaymentCreditAddCardError();
            }
          }
        });
      } catch (e) {
        console.error("error", e);
      } finally {
        this.loadingAddCreditCard = false;
      }
    },
    async checkOut() {
      try {
        this.loadingCheckOut = true;
        let secretkey = process.env.VUE_APP_GB_SECRET_KEY;

        let urlBackoffice = process.env.VUE_APP_BASE_MANA_BACKOFFICE_URL;

        let obj = {
          amount:
            this.user.email === "pinyo.tadsomboon@gmail.com"
              ? 1
              : this.totalPaymant,
          referenceNo: this.referenceNo,
          detail: `แพ็คเกจใช้งาน MANA Premium User`,
          customerName: `${this.user.name} ${this.user.surname}`,
          customerEmail: this.user.email,
          customerAddress: "",
          customerTelephone: this.user.mobilephone,
          merchantDefined1: `คุณได้ซื้อแพ็คเกจใช้งาน Premium User ของ MANA แบบ${
            this.formUpgrade.promotion === 1 ? "รายเดือน" : "รายปี"
          }จำนวน ${this.formUpgrade.numUser} User`,
          card: {
            token: this.tokenCheckOut,
          },
          otp: "Y",
          responseUrl: `${urlBackoffice}api/payment/gb/response`,
          backgroundUrl: `${urlBackoffice}api/payment/gb/background`,
        };

        HTTP_GB.defaults.headers.common.Authorization = `Basic ${btoa(
          `${secretkey}:`
        )}`;

        let res = await HTTP_GB.post("v2/tokens/charge", obj);
        if (res.data.resultCode == "00") {
          this.secured(res.data.gbpReferenceNo);
        } else if (res.data.resultCode == "05") {
          this.alertPaymentCreditDoNotHonour();
        } else if (res.data.resultCode == "14") {
          this.alertPaymentCreditInvalidCardNumber();
        } else if (res.data.resultCode == "41" || res.data.resultCode == "43") {
          this.alertPaymentCreditCardCanceled();
        } else if (res.data.resultCode == "54") {
          this.alertPaymentCreditExpiredCard();
        } else {
          this.alertPaymentCreditError();
          this.dialogVisibleUpgrade = false;
        }
      } catch (e) {
        console.error("error", e);
      } finally {
        this.loadingCheckOut = false;
      }
    },
    async secured(gbpReferenceNo) {
      try {
        let publicKey = process.env.VUE_APP_GB_PUBLIC_KEY;

        const config = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        };

        let obj = {
          gbpReferenceNo: gbpReferenceNo,
          publicKey: publicKey,
        };

        let res = await HTTP_GB.post(
          process.env.VUE_APP_GB + "v2/tokens/3d_secured",
          qs.stringify(obj),
          config
        );

        var oWindow = window.open(
          "",
          "printWindow",
          "width=1200px,height=900px"
        );

        oWindow.document.open("text/html", "replace");
        oWindow.document.write(res.data);
        oWindow.document.write("<h4>กรุณารอสักครู่...</h4>");
        oWindow.document.close();
      } catch (e) {
        console.error("error", e);
      } finally {
        this.loadingCheckOut = false;
      }
    },

    nextPayment() {
      this.$refs["form-upgrade"].validate().then(async (valid) => {
        if (valid) {
          this.formUpgrade.step = 3;
        }
      });
    },
    getTotalPackage(formUpgrade) {
      let price = formUpgrade.promotion === 1 ? 250 : 2700;

      return formUpgrade.numUser * price;
    },
    updateValidate() {
      this.$refs["form-credit"].validateField("expiration");
    },
  },
};
</script>
